import React, { useEffect } from "react";
import { Button } from "../atoms/button"
import { Label } from "../atoms/label"
import useMedia from 'use-media';
import { useState } from 'react'

export const PlanSetForm = (props) => {
    //レスポンシブ対応
    const isWidePhone = useMedia({ maxWidth: '480px' });
    const isWideTablet = useMedia({ maxWidth: '960px' });
    const [Phone, setPhone] = useState(false);
    const [Tablet, setTablet] = useState(false);
    const numberWithComma = new Intl.NumberFormat();

    useEffect(() => {
        if (isWideTablet && isWidePhone) {
            setPhone(true);
            setTablet(false);
        }
        else if (isWideTablet && !isWidePhone) {
            setPhone(false);
            setTablet(true);
        }
        else if (!isWideTablet && isWidePhone) {
            setTablet(false);
            setPhone(true);
        }
        else {
            setPhone(false);
            setTablet(false);
        }
    })

    return (
        <div style={Phone ? {border:"1px solid #e0e0e0",padding:"20px 5% 5%",marginBottom:"10px"} : {border:"1px solid #e0e0e0",padding:"20px 5% 5%",marginBottom:"10px"}}>
            <Label label={props.title} style={styles.titleStr} />
            <div style={Phone ? styles.tableSp : styles.table}>
                <div style={Phone ? styles.tableChildSp : styles.tableChild}>
                    {props.priceDispFlg ?
                    <div style={styles.member}>
                        <Label label="メンバー" style={styles.titlePrice} />
                        <Label label={props.memberPrice != null ? "￥" + numberWithComma.format(props.memberPrice) + "～" : ""} style={styles.valuePrice} />
                    </div>
                    : null
                    }
                    {/* <div style={styles.guest}>
                        <Label label="ゲスト" style={styles.titlePrice} />
                        <Label label={props.guestPrice != null ? "￥" + numberWithComma.format(props.guestPrice) + "～" : ""} style={styles.valuePrice} />
                    </div> */}
                </div>
                <div style={Phone ? styles.buttonSp : styles.button}>
                    <Button buttonText="プラン詳細"
                        className={Phone ? "btnPlanDetailSpGolf" : "btnPlanDetailGolf"}
                        onClick={() => { props.clickDetail(props.paretnIndex, props.index,props.planType) }} />
                    <Button
                        buttonText="予約する"
                        className={Phone ? "btnReservationSpGolf" : "btnReservationGolf"}
                        onClick={() => { props.onClick(props.paretnIndex, props.index,props.planType) }} />
                </div>
            </div>
        </div>
    );
};

const styles = {
    titleStr: {
        fontWeight: "bold",
        // marginBottom: "20px",

    },
    member: {

    },
    guest: {

    },
    titlePrice: {
        display: "inline-block",
        width: "60px",
        fontSize: "small",
    },
    valuePrice: {
        display: "inline-block",
        fontWeight: "bold",
        fontSize: "small",
    },
    table: {
        // display: "table",
        width: "100%",
        display:"flex",
        alignItems:"center",
        justifyContent:"space-between"
    },
    tableSp: {
        width: "100%",
        marginTop:"10px"
    },
    tableChild: {
        display: "table-cell",
    },
    tableChildSp: {
    },
    button: {
        display: "table-cell",
        textAlign: "right",
        verticalAlign: "bottom",
    },
    buttonSp: {
        display: "flex",
        textAlign: "right",
        verticalAlign: "bottom",
        marginTop: "20px",
        justifyContent: "space-between",
    }
}